<template>
    <div>
        <page-navigate></page-navigate>
        <div id="pageContainer">
           <section class="container1">
      <div class="contentBox container1Content">
        <div class="left">
          <div class="container1-copy">
            <h1 class="super_large-80_bold md-title-32_bold word1">一站布局<br />热门美股资产</h1>
            <div class="subtitle-20_regular md-body-14_regular word2 container1-desc">
              <p class="container1-offer">
                <span>0 手续费、0 隔夜利息</span>
                <span class="container1-tipWrap" role="button" tabindex="0" aria-expanded="false">
                  <img class="container1-tipIcon" src="@/assets/image/trading-product/share-cfds/headIconTip.png" alt="" />
                  <span class="container1-tooltip" role="tooltip">
                    <button class="container1-tooltipClose" type="button" aria-label="关闭"></button>
                    <strong>活动规则</strong>
                    <span>活动期间，平台美股 CFD 产品均可享受 0 手续费和 0 隔夜利息。</span>
                    <span><b>活动时间</b>2026年6月12日 至 2026年9月11日 <time>（UTC+3）</time></span>
                    <span><b>单笔限制</b>单个账号买入或卖出，单笔最大均为 50 股。</span>
                    <span><b>持仓限制</b>单个账号、单个股票品种，买入方向与卖出方向持仓上限各为 1000 股。</span>
                    <span><b>活动前后持仓说明</b><span>6月12日前已有持仓，并在活动期间平仓，不收取平仓手续费。</span><span>活动期间持仓，如在9月11日活动结束后平仓，平仓手续费按正常标准收取。</span> </span>
                  </span>
                </span>
              </p>
              <p>交易 SpaceX、美光科技、英伟达等热门美股 CFD</p>
            </div>
            <div class="container1-tags body-14_regular md-footnote-regular_12">
              <span><img src="@/assets/image/trading-product/share-cfds/headIconYes.png" alt="" />5倍杠杆</span>
              <span><img src="@/assets/image/trading-product/share-cfds/headIconYes.png" alt="" />多空交易</span>
              <span><img src="@/assets/image/trading-product/share-cfds/headIconYes.png" alt="" />享受股息</span>
            </div>
          </div>
          <div class="container1-actions">
            <a :href="signupUrl" target="_blank">
              <div class="btn primary-default_large">
                <span class="word3">立即开户</span>
                <span class="iconfont icon-right"></span>
              </div>
            </a>
            
          </div>
        </div>
        <div class="right container1-carousel" aria-hidden="true">
          <div class="container1-carouselCol">
            <div class="container1-carouselTrack">
              <div class="container1-card">
                <img class="container1-cardMedia" src="@/assets/image/trading-product/share-cfds/headLeft1.png" alt="" loading="lazy" />
                <div class="container1-cardInfo">
                  <div class="container1-cardLogo"><img src="@/assets/image/trading-product/share-cfds/headLeft1Logo.png" alt="" loading="lazy" /></div>
                  <div><span class="container1-cardName" data-stock-card-name="LRCX">泛林</span><span class="container1-cardRate" data-stock-card-rate="LRCX">+965.45%</span></div>
                </div>
              </div>
              <div class="container1-card">
                <video class="container1-cardMedia" src="@/assets/image/trading-product/share-cfds/headLeft2.mp4" autoplay muted loop playsinline webkit-playsinline preload="metadata"></video>
                <div class="container1-cardInfo">
                  <div class="container1-cardLogo"><img src="@/assets/image/trading-product/share-cfds/headLeft2Logo.png" alt="" loading="lazy" /></div>
                  <div><span class="container1-cardName" data-stock-card-name="GOOGL">谷歌</span><span class="container1-cardRate" data-stock-card-rate="GOOGL">+65.45%</span></div>
                </div>
              </div>
              <div class="container1-card">
                <video class="container1-cardMedia" src="@/assets/image/trading-product/share-cfds/headLeft3.mp4" autoplay muted loop playsinline webkit-playsinline preload="metadata"></video>
                <div class="container1-cardInfo">
                  <div class="container1-cardLogo"><img src="@/assets/image/trading-product/share-cfds/headLeft3Logo.png" alt="" loading="lazy" /></div>
                  <div><span class="container1-cardName" data-stock-card-name="AAPL">苹果</span><span class="container1-cardRate" data-stock-card-rate="AAPL">+37.43%</span></div>
                </div>
              </div>
              <div class="container1-card">
                <video class="container1-cardMedia" src="@/assets/image/trading-product/share-cfds/headLeft4.mp4" autoplay muted loop playsinline webkit-playsinline preload="metadata"></video>
                <div class="container1-cardInfo">
                  <div class="container1-cardLogo"><img src="@/assets/image/trading-product/share-cfds/headLeft4Logo.png" alt="" loading="lazy" /></div>
                  <div><span class="container1-cardName" data-stock-card-name="AMD">美国超微</span><span class="container1-cardRate" data-stock-card-rate="AMD">+270.66%</span></div>
                </div>
              </div>
              <div class="container1-card">
                <img class="container1-cardMedia" src="@/assets/image/trading-product/share-cfds/headLeft5.png" alt="" loading="lazy" />
                <div class="container1-cardInfo">
                  <div class="container1-cardLogo"><img src="@/assets/image/trading-product/share-cfds/headLeft5Logo.png" alt="" loading="lazy" /></div>
                  <div><span class="container1-cardName" data-stock-card-name="SNDK">闪迪</span><span class="container1-cardRate" data-stock-card-rate="SNDK">+490.53%</span></div>
                </div>
              </div>
              <div class="container1-card">
                <img class="container1-cardMedia" src="@/assets/image/trading-product/share-cfds/headLeft6.png" alt="" loading="lazy" />
                <div class="container1-cardInfo">
                  <div class="container1-cardLogo"><img src="@/assets/image/trading-product/share-cfds/headLeft6Logo.png" alt="" loading="lazy" /></div>
                  <div><span class="container1-cardName" data-stock-card-name="CSCO">思科</span><span class="container1-cardRate" data-stock-card-rate="CSCO">+120.31%</span></div>
                </div>
              </div>
              
            </div>
          </div>
          <div class="container1-carouselCol">
            <div class="container1-carouselTrack container1-carouselTrackDown">
              <div class="container1-card">
                <video class="container1-cardMedia" src="@/assets/image/trading-product/share-cfds/headRight1.mp4" autoplay muted loop playsinline webkit-playsinline preload="metadata"></video>
                <div class="container1-cardInfo">
                  <div class="container1-cardLogo"><img src="@/assets/image/trading-product/share-cfds/headRight1Logo.png" alt="" loading="lazy" /></div>
                  <div><span class="container1-cardName" data-stock-card-name="MU">美光科技</span><span class="container1-cardRate" data-stock-card-rate="MU">+865.45%</span></div>
                </div>
              </div>
              <div class="container1-card">
                <img class="container1-cardMedia" src="@/assets/image/trading-product/share-cfds/headRight2.png" alt="" loading="lazy" />
                <div class="container1-cardInfo">
                  <div class="container1-cardLogo"><img src="@/assets/image/trading-product/share-cfds/headRight2Logo.png" alt="" loading="lazy" /></div>
                  <div><span class="container1-cardName" data-stock-card-name="INTC">英特尔</span><span class="container1-cardRate" data-stock-card-rate="INTC">+490.53%</span></div>
                </div>
              </div>
              <div class="container1-card">
                <img class="container1-cardMedia" src="@/assets/image/trading-product/share-cfds/headRight3.png" alt="" loading="lazy" />
                <div class="container1-cardInfo">
                  <div class="container1-cardLogo"><img src="@/assets/image/trading-product/share-cfds/headRight3Logo.png" alt="" loading="lazy" /></div>
                  <div><span class="container1-cardName" data-stock-card-name="NVDA">英伟达</span><span class="container1-cardRate" data-stock-card-rate="NVDA">+26.44%</span></div>
                </div>
              </div>
              <div class="container1-card">
                <video class="container1-cardMedia" src="@/assets/image/trading-product/share-cfds/headRight4.mp4" autoplay muted loop playsinline webkit-playsinline preload="metadata"></video>
                <div class="container1-cardInfo">
                  <div class="container1-cardLogo"><img src="@/assets/image/trading-product/share-cfds/headRight4Logo.png" alt="" loading="lazy" /></div>
                  <div><span class="container1-cardName" data-stock-card-name="ASML">阿斯麦</span><span class="container1-cardRate" data-stock-card-rate="ASML">+65.45%</span></div>
                </div>
              </div>
              <div class="container1-card">
                <img class="container1-cardMedia" src="@/assets/image/trading-product/share-cfds/headRight5.png" alt="" loading="lazy" />
                <div class="container1-cardInfo">
                  <div class="container1-cardLogo"><img src="@/assets/image/trading-product/share-cfds/headRight5Logo.png" alt="" loading="lazy" /></div>
                  <div><span class="container1-cardName" data-stock-card-name="AVGO">博通</span><span class="container1-cardRate" data-stock-card-rate="AVGO">+58.46%</span></div>
                </div>
              </div>
              <div class="container1-card">
                <img class="container1-cardMedia" src="@/assets/image/trading-product/share-cfds/headRight6.png" alt="" loading="lazy" />
                <div class="container1-cardInfo">
                  <div class="container1-cardLogo"><img src="@/assets/image/trading-product/share-cfds/headRight6Logo.png" alt="" loading="lazy" /></div>
                  <div><span class="container1-cardName" data-stock-card-name="MRVL">迈威尔科技</span><span class="container1-cardRate" data-stock-card-rate="MRVL">+93.12%</span></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
            <product-tab></product-tab>
        <section class="shareAiCore">
      <div class="contentBox">
        <div class="shareAiCore-head">
          <h2 class="title-48_bold scroll-fade-up">交易 AI 核心资产</h2>
          <p class="subtitle-20_regular scroll-fade-up">通过美股 CFD 交易芯片、存储与光通信等 AI 产业链热门标的</p>
        </div>

        <div class="shareAiCore-layout">
          <div class="shareAiCore-leftCard scroll-fade-left">
            <picture class="shareAiCore-picture">
              <img class="shareAiCore-leftImg" src="@/assets/image/trading-product/share-cfds/section2Left.webp" alt="" loading="lazy" />
            </picture>
            <div class="shareAiCore-leftText">
              <p class="subtitle-20_regular">美股 CFD 热门标的</p>
              <h3 class="title-48_bold">AI 核心资产</h3>
              <a class="shareAiCore-btn content-16_medium md-body-14_medium" href="#share-cfds-products">查看热门标的</a>
            </div>
          </div>

          <div class="shareAiCore-cardList scroll-fade-right">
            <div class="shareAiCore-card">
              <div class="shareAiCore-cardTop">
                <h3 class="subtitle-20_bold">算力芯片</h3>
                <div class="shareAiCore-tags">
                  <span>GPU</span>
                  <span>芯片设计</span>
                  <span>半导体设备</span>
                </div>
              </div>
              <div class="shareAiCore-stocks">
                <div class="shareAiCore-stock">
                  <span class="shareAiCore-logo"><img src="@/assets/image/trading-product/share-cfds/section2Logo1.png" alt="" loading="lazy" /></span>
                  <span data-stock-summary="NVDA"><b>英伟达</b><em>+26.44%</em></span>
                </div>
                <div class="shareAiCore-stock">
                  <span class="shareAiCore-logo"><img src="@/assets/image/trading-product/share-cfds/section2Logo2.png" alt="" loading="lazy" /></span>
                  <span data-stock-summary="AMD"><b>美国超微</b><em>+270.66%</em></span>
                </div>
                <div class="shareAiCore-stock">
                  <span class="shareAiCore-logo"><img src="@/assets/image/trading-product/share-cfds/section2Logo3.png" alt="" loading="lazy" /></span>
                  <span data-stock-summary="ASML"><b>阿斯麦</b><em>+132.51%</em></span>
                </div>
              </div>
            </div>

            <div class="shareAiCore-card">
              <div class="shareAiCore-cardTop">
                <h3 class="subtitle-20_bold">存储与 HBM</h3>
                <div class="shareAiCore-tags">
                  <span>高带宽存储</span>
                  <span>内存芯片</span>
                  <span>企业级存储</span>
                </div>
              </div>
              <div class="shareAiCore-stocks">
                <div class="shareAiCore-stock">
                  <span class="shareAiCore-logo"><img src="@/assets/image/trading-product/share-cfds/section2Logo4.png" alt="" loading="lazy" /></span>
                  <span data-stock-summary="MU"><b>美光科技</b><em>+865.45%</em></span>
                </div>
                <div class="shareAiCore-stock">
                  <span class="shareAiCore-logo"><img src="@/assets/image/trading-product/share-cfds/section2Logo5.png" alt="" loading="lazy" /></span>
                  <span data-stock-summary="SNDK"><b>闪迪</b><em>+4,830%</em></span>
                </div>
              </div>
            </div>

            <div class="shareAiCore-card">
              <div class="shareAiCore-cardTop">
                <h3 class="subtitle-20_bold">光通信与数据中心</h3>
                <div class="shareAiCore-tags">
                  <span>光模块</span>
                  <span>高速连接</span>
                  <span>数据中心</span>
                </div>
              </div>
              <div class="shareAiCore-stocks">
                <div class="shareAiCore-stock">
                  <span class="shareAiCore-logo"><img src="@/assets/image/trading-product/share-cfds/section2Logo6.png" alt="" loading="lazy" /></span>
                  <span data-stock-summary="AVGO"><b>博通</b><em>+41.28%</em></span>
                </div>
                <div class="shareAiCore-stock">
                  <span class="shareAiCore-logo"><img src="@/assets/image/trading-product/share-cfds/section2Logo7.png" alt="" loading="lazy" /></span>
                  <span data-stock-summary="COHR"><b>高意</b><em>+376%</em></span>
                </div>
                <div class="shareAiCore-stock">
                  <span class="shareAiCore-logo"><img src="@/assets/image/trading-product/share-cfds/section2Logo8.png" alt="" loading="lazy" /></span>
                  <span data-stock-summary="MRVL"><b>迈威尔科技</b><em>+265%</em></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="shareHotLines">
      <div class="contentBox">
        <div class="shareHotLines-head">
          <h2 class="title-48_bold scroll-fade-up">聚焦高热度美股主线</h2>
          <p class="subtitle-20_regular scroll-fade-up">从 AI 芯片到科技龙头与光通信基建，捕捉高关注度美股价格波动</p>
        </div>

        <div class="shareHotLines-grid scroll-fade-up">
          <div class="shareHotLines-card">
            <h3 class="title-24_medium">半导体与 AI 芯片</h3>
            <div class="shareHotLines-list">
              <div class="shareHotLines-stock">
                <span class="shareHotLines-logo"><img src="@/assets/image/trading-product/share-cfds/section3Logo1.png" alt="" loading="lazy" /></span>
                <span class="shareHotLines-stockText" data-stock-line-text="MU"><b>美光科技</b><em>MU.OQ</em></span>
                <span class="shareHotLines-rate" data-stock-line-rate="MU"><b>近 1 年</b><em>+865.45%</em></span>
              </div>
              <div class="shareHotLines-stock">
                <span class="shareHotLines-logo"><img src="@/assets/image/trading-product/share-cfds/section3Logo2.png" alt="" loading="lazy" /></span>
                <span class="shareHotLines-stockText" data-stock-line-text="INTC"><b>英特尔</b><em>INTC.OQ</em></span>
                <span class="shareHotLines-rate" data-stock-line-rate="INTC"><b>近 1 年</b><em>+490.53%</em></span>
              </div>
              <div class="shareHotLines-stock">
                <span class="shareHotLines-logo"><img src="@/assets/image/trading-product/share-cfds/section3Logo3.png" alt="" loading="lazy" /></span>
                <span class="shareHotLines-stockText" data-stock-line-text="LRCX"><b>泛林集团</b><em>LRCX.OQ</em></span>
                <span class="shareHotLines-rate" data-stock-line-rate="LRCX"><b>近 1 年</b><em>+317.23%</em></span>
              </div>
              <div class="shareHotLines-stock">
                <span class="shareHotLines-logo"><img src="@/assets/image/trading-product/share-cfds/section3Logo4.png" alt="" loading="lazy" /></span>
                <span class="shareHotLines-stockText" data-stock-line-text="AMD"><b>美国超微</b><em>AMD.OQ</em></span>
                <span class="shareHotLines-rate" data-stock-line-rate="AMD"><b>近 1 年</b><em>+270.66%</em></span>
              </div>
            </div>
          </div>

          <div class="shareHotLines-card">
            <h3 class="title-24_medium">AI科技与云计算</h3>
            <div class="shareHotLines-list">
              <div class="shareHotLines-stock">
                <span class="shareHotLines-logo"><img src="@/assets/image/trading-product/share-cfds/section3Logo5.png" alt="" loading="lazy" /></span>
                <span class="shareHotLines-stockText" data-stock-line-text="GOOGL"><b>谷歌A</b><em>GOOGL.OQ</em></span>
                <span class="shareHotLines-rate" data-stock-line-rate="GOOGL"><b>近 1 年</b><em>+98.62%</em></span>
              </div>
              <div class="shareHotLines-stock">
                <span class="shareHotLines-logo"><img src="@/assets/image/trading-product/share-cfds/section3Logo6.png" alt="" loading="lazy" /></span>
                <span class="shareHotLines-stockText" data-stock-line-text="CSCO"><b>思科</b><em>CSCO.OQ</em></span>
                <span class="shareHotLines-rate" data-stock-line-rate="CSCO"><b>近 1 年</b><em>+76.52%</em></span>
              </div>
              <div class="shareHotLines-stock">
                <span class="shareHotLines-logo"><img src="@/assets/image/trading-product/share-cfds/section3Logo7.png" alt="" loading="lazy" /></span>
                <span class="shareHotLines-stockText" data-stock-line-text="AVGO"><b>博通</b><em>AVGO.OQ</em></span>
                <span class="shareHotLines-rate" data-stock-line-rate="AVGO"><b>近 1 年</b><em>+41.28%</em></span>
              </div>
              <div class="shareHotLines-stock">
                <span class="shareHotLines-logo"><img src="@/assets/image/trading-product/share-cfds/section3Logo8.png" alt="" loading="lazy" /></span>
                <span class="shareHotLines-stockText" data-stock-line-text="AAPL"><b>苹果公司</b><em>AAPL.OQ</em></span>
                <span class="shareHotLines-rate" data-stock-line-rate="AAPL"><b>近 1 年</b><em>+37.43%</em></span>
              </div>
            </div>
          </div>

          <div class="shareHotLines-card">
            <h3 class="title-24_medium">光通信与AI基建</h3>
            <div class="shareHotLines-list">
              <div class="shareHotLines-stock">
                <span class="shareHotLines-logo"><img src="@/assets/image/trading-product/share-cfds/section3Logo9.png" alt="" loading="lazy" /></span>
                <span class="shareHotLines-stockText" data-stock-line-text="COHR"><b>高意</b><em>COHR.N</em></span>
                <span class="shareHotLines-rate" data-stock-line-rate="COHR"><b>近 1 年</b><em>+62.10%</em></span>
              </div>
              <div class="shareHotLines-stock">
                <span class="shareHotLines-logo"><img src="@/assets/image/trading-product/share-cfds/section3Logo10.png" alt="" loading="lazy" /></span>
                <span class="shareHotLines-stockText" data-stock-line-text="LITE"><b>朗美通</b><em>LITE.OQ</em></span>
                <span class="shareHotLines-rate" data-stock-line-rate="LITE"><b>近 1 年</b><em>+48.35%</em></span>
              </div>
              <div class="shareHotLines-stock">
                <span class="shareHotLines-logo"><img src="@/assets/image/trading-product/share-cfds/section3Logo11.png" alt="" loading="lazy" /></span>
                <span class="shareHotLines-stockText" data-stock-line-text="MRVL"><b>迈威尔科技</b><em>MRVL.OQ</em></span>
                <span class="shareHotLines-rate" data-stock-line-rate="MRVL"><b>近 1 年</b><em>+33.72%</em></span>
              </div>
              <div class="shareHotLines-stock">
                <span class="shareHotLines-logo"><img src="@/assets/image/trading-product/share-cfds/section3Logo12.png" alt="" loading="lazy" /></span>
                <span class="shareHotLines-stockText" data-stock-line-text="GLW"><b>康宁</b><em>GLW.N</em></span>
                <span class="shareHotLines-rate" data-stock-line-rate="GLW"><b>近 1 年</b><em>+27.44%</em></span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>


    <section class="container2" id="share-cfds-products">
      <div class="contentBox container2Content">
        <h2 class="text-center title-48_bold md-title-24_bold scroll-fade-up">交易热门美股 CFD 实时报价</h2>
        <div class="shareTradingHours body-16_regular md-body-14_regular scroll-fade-up">
          <div class="shareTradingHours-label">
            <img src="@/assets/image/trading-product/share-cfds/section4Logo.png" alt="" loading="lazy" />
            <span>交易时间</span>
          </div>
          <span class="shareTradingHours-divider"></span>
          <div class="shareTradingHours-text">
            <div><strong>平台时间（UTC+3）：</strong><span>周一至周五 16:31 - 22:59</span></div>
            <div><strong>每日休市：</strong><span>22:59 - 次日 16:31 · 以 MT 平台显示为准</span></div>
          </div>
        </div>
        <product-module-new />
      </div>
    </section>
            <open-account openAccountTitle="开始交易美股 CFD" openAccountDesc="3步轻松开户，客服全程支持，快速开启您的交易旅程"></open-account>
            <section class="container4 commonQuestion">
                <div class="contentBox">
                    <h2 class="scroll-fade-up">美股 CFD 合约相关问题</h2>
                    <div class="QA-list">
                        <div class="QA-item">
                            <div class="QA-title">1.什么是股票CFD？</div>
                            <div class="QA-content">
                                <p class="QA-li">
                                    股票CFD（差价合约）是一种金融衍生品，使投资者可以无需实际持有股票即可通过价格波动获利。<br>
通过交易股票CFD，投资者可以规避传统股票交易中的额外成本（如印花税），同时享受多空双向交易的灵活性，无论市场涨跌均可把握机会。
                                </p>
                            </div>
                        </div>
                        <div class="QA-item">
                            <div class="QA-title">2. 股票CFD可以交易什么？</div>
                            <div class="QA-content">
                                <p class="QA-li">
                                    EBC精选100+全球热门美股，覆盖半导体、AI 科技、存储、光通信、金融、能源等市场关注方向，为投资者提供具有竞争力的交易成本和多空双向操作的灵活性。结合卓越的流动性支持，EBC确保投资者的交易体验更高效、更便捷。
                                </p>
                            </div>
                        </div>

                        <div class="QA-item">
                            <div class="QA-title">3. 股票CFD交易杠杆</div>
                            <div class="QA-content">
                                <p class="QA-li">
                                    EBC股票CFD提供1:5杠杆，投资者仅需少量资金即可参与全球顶尖企业的投资，扩大收益潜力。但需注意，杠杆虽然使投资者能够以较低的成本参与更大规模的交易，有效提高资金利用率，但同样会放大市场波动带来的风险，不利行情可能导致更大的损失。
                                </p>
                            </div>
                        </div>
                        <div class="QA-item">
                            <div class="QA-title">4. 如何参与股票CFD交易？</div>
                            <div class="QA-content">
                                <p class="QA-li">
                                    股票CFD交易与传统股票交易类似，但无需实际持有股票。交易价格受企业财务状况及市场表现的影响。<br>

投资者在参与前，应了解企业的财务指标（如市盈率、市净率）以评估其投资价值。例如，当企业市盈率低于行业平均水平时，可能存在被低估的投资机会。<br>

EBC甄选全球范围内流动性强、财务表现优异的公司，助力投资者精准发掘价值潜力。
                                </p>
                            </div>
                        </div>
                        <div class="QA-item">
                            <div class="QA-title">5. 股票CFD如何获得股息？</div>
                            <div class="QA-content">
                                <p class="QA-li">
                                    在股票CFD交易中，投资者同样有机会享受股息收益。例如，当某公司宣布每股派息0.32美元，投资者持有10000股相关CFD，即可获得3200美元的股息收入。<br>

在EBC平台交易股票CFD，只需在除息日前一天持有相关CFD合约，即可在派息日收到股息收益。
                                </p>
                            </div>
                        </div>
<div class="QA-item">
            <div class="QA-title">6.如何享受 0 手续费和 0 隔夜利息？</div>
            <div class="QA-content">
              <p class="QA-li">
                活动期间，平台美股 CFD 产品均可享受 0 手续费和 0 隔夜利息。具体执行规则以官网活动规则及 MT 平台显示为准。<button class="shareRuleLink" type="button" data-share-rule-trigger>查看活动规则</button>
              </p>
            </div>
          </div>
          <div class="QA-item">
            <div class="QA-title">7.美股 CFD 的交易时间</div>
            <div class="QA-content">
              <p class="QA-li">
                美股 CFD 交易时间为平台时间（UTC+3）周一至周五 16:31 - 22:59；每日休市时间为 22:59 - 次日 16:31。实际可交易时间以 MT 平台显示为准。
              </p>
            </div>
          </div>
                    </div>
                </div>
            </section>
        </div>
        <message-v3></message-v3>

        <page-footer></page-footer>
    </div>
</template>

<script>
import fadeAnimate from "../mixins/fadeAnimate.js";
import {
    mapGetters,
} from 'vuex'
export default {
    mixins: [fadeAnimate],
    data() {
        return {
            infoData: "",
            newData: "",
            pagIndex: 0,
            num: 3,
            newsdisplay: "none"
        }
    },
    computed: {
        ...mapGetters([
            'signupUrl',
        ]),
    },
    destroyed() {
    },

    mounted() {
        this.initPage()
        this.initPage2()
    },
    methods: {
        initPage2(){
            (function () {
  function normalizeVideo(video) {
    video.muted = true;
    video.loop = true;
    video.autoplay = true;
    video.playsInline = true;
    video.setAttribute("muted", "");
    video.setAttribute("loop", "");
    video.setAttribute("autoplay", "");
    video.setAttribute("playsinline", "");
    video.setAttribute("webkit-playsinline", "");
  }

  function cloneHeroCarouselTrack(track) {
    if (!track || track.getAttribute("data-cloned") === "true") {
      return;
    }

    var cards = Array.prototype.slice.call(track.children);
    var fragment = document.createDocumentFragment();

    cards.forEach(function (card) {
      var clone = card.cloneNode(true);
      clone.setAttribute("aria-hidden", "true");
      clone.setAttribute("data-clone", "true");

      Array.prototype.forEach.call(clone.querySelectorAll("video"), normalizeVideo);
      fragment.appendChild(clone);
    });

    Array.prototype.forEach.call(track.querySelectorAll("video"), normalizeVideo);
    track.appendChild(fragment);
    track.setAttribute("data-cloned", "true");
  }

  function initHeroCarouselClone() {
    Array.prototype.forEach.call(
      document.querySelectorAll(".container1-carouselTrack"),
      cloneHeroCarouselTrack
    );

    var carousel = document.querySelector(".container1-carousel");
    if (carousel) {
      carousel.classList.add("is-ready");
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initHeroCarouselClone);
  } else {
    initHeroCarouselClone();
  }
})();


const stockPageData = [
  {
    "symbol": "SPCX",
    "symbolEn": "SpaceX",
    "symbolZh": "SpaceX",
    "symbolFan": "SpaceX",
    "stockData": {
      "perData": {
        "yearData": "+1.44%"
      }
    }
  },
  {
    "symbol": "AAPL",
    "symbolEn": "Apple Inc.",
    "symbolZh": "苹果公司",
    "symbolFan": "蘋果公司",
    "stockData": {
      "perData": {
        "yearData": "+50.92%"
      }
    }
  },
  {
    "symbol": "TSLA",
    "symbolEn": "Tesla, Inc.",
    "symbolZh": "特斯拉公司",
    "symbolFan": "特斯拉公司",
    "stockData": {
      "perData": {
        "yearData": "+36.63%"
      }
    }
  },
  {
    "symbol": "NVDA",
    "symbolEn": "NVIDIA Corporation",
    "symbolZh": "英伟达公司",
    "symbolFan": "英偉達公司",
    "stockData": {
      "perData": {
        "yearData": "+25.78%"
      }
    }
  },
  {
    "symbol": "GOOGL",
    "extraSymbol": "GOOG",
    "symbolEn": "Alphabet Inc.",
    "symbolZh": "谷歌A",
    "symbolFan": "谷歌A",
    "stockData": {
      "perData": {
        "yearData": "+102.28%"
      }
    }
  },
  {
    "symbol": "INTC",
    "symbolEn": "Intel Corporation",
    "symbolZh": "英特尔公司",
    "symbolFan": "英特爾公司",
    "stockData": {
      "perData": {
        "yearData": "+383.21%"
      }
    }
  },
  {
    "symbol": "CSCO",
    "symbolEn": "Cisco Systems, Inc.",
    "symbolZh": "思科",
    "symbolFan": "思科",
    "stockData": {
      "perData": {
        "yearData": "+72.61%"
      }
    }
  },
  {
    "symbol": "MU",
    "symbolEn": "Micron Technology, Inc.",
    "symbolZh": "美光科技",
    "symbolFan": "美光科技",
    "stockData": {
      "perData": {
        "yearData": "+694.49%"
      }
    }
  },
  {
    "symbol": "AMD",
    "symbolEn": "Advanced Micro Devices, Inc.",
    "symbolZh": "美国超微公司",
    "symbolFan": "美國超微公司",
    "stockData": {
      "perData": {
        "yearData": "+294.20%"
      }
    }
  },
  {
    "symbol": "ASML",
    "symbolEn": "ASML Holding N.V.",
    "symbolZh": "阿斯麦",
    "symbolFan": "阿斯麥",
    "stockData": {
      "perData": {
        "yearData": "+127.55%"
      }
    }
  },
  {
    "symbol": "SNDK",
    "symbolEn": "SanDisk Corporation",
    "symbolZh": "闪迪",
    "symbolFan": "閃迪",
    "stockData": {
      "perData": {
        "yearData": "+3929.21%"
      }
    }
  },
  {
    "symbol": "AVGO",
    "symbolEn": "Broadcom Inc.",
    "symbolZh": "博通",
    "symbolFan": "博通",
    "stockData": {
      "perData": {
        "yearData": "+46.95%"
      }
    }
  },
  {
    "symbol": "COHR",
    "symbolEn": "Coherent Corp.",
    "symbolZh": "高意",
    "symbolFan": "高意",
    "stockData": {
      "perData": {
        "yearData": "+258.07%"
      }
    }
  },
  {
    "symbol": "MRVL",
    "symbolEn": "Marvell Technology, Inc.",
    "symbolZh": "迈威尔科技",
    "symbolFan": "邁威爾科技",
    "stockData": {
      "perData": {
        "yearData": "+235.50%"
      }
    }
  },
  {
    "symbol": "LRCX",
    "symbolEn": "Lam Research Corporation",
    "symbolZh": "泛林集团",
    "symbolFan": "泛林集團",
    "stockData": {
      "perData": {
        "yearData": "+253.88%"
      }
    }
  },
  {
    "symbol": "LITE",
    "symbolEn": "Lumentum Holdings Inc.",
    "symbolZh": "朗美通",
    "symbolFan": "朗美通",
    "stockData": {
      "perData": {
        "yearData": "+759.14%"
      }
    }
  },
  {
    "symbol": "GLW",
    "symbolEn": "Corning Incorporated",
    "symbolZh": "康宁公司",
    "symbolFan": "康寧公司",
    "stockData": {
      "perData": {
        "yearData": "+261.89%"
      }
    }
  }
];

(function () {
  var stockMap = {};

  function getLangKey() {
    var langKeys = [
      "zh-cn",
      "zh",
      "jp",
      "kr",
      "th",
      "id",
      "vi",
      "pt",
      "es",
      "ru",
      "hi",
      "ar",
      "mn",
      "ug"
    ];
    var href = window.location.href;
    for (var i = 0; i < langKeys.length; i += 1) {
      if (href.indexOf("/" + langKeys[i] + "/") > -1) {
        return langKeys[i];
      }
    }
    return "default";
  }

  function getStockName(stock, langKey) {
    if (!stock) return "";
    return stock.symbolZh || stock.symbol || "";
  }

  function getStockYearData(stock) {
    return stock && stock.stockData && stock.stockData.perData && stock.stockData.perData.yearData
      ? stock.stockData.perData.yearData
      : "";
  }

  function updatePercentClass(element, value) {
    if (!element) return;
    element.classList.remove("is-negative", "is-positive");
    if (String(value).indexOf("-") > -1) {
      element.classList.add("is-negative");
    } else if (String(value).indexOf("+") > -1) {
      element.classList.add("is-positive");
    }
  }

  function hydrateStockSummary(element, stock, langKey) {
    if (!stock) return;
    var name = element.querySelector("b");
    var rate = element.querySelector("em");
    var yearData = getStockYearData(stock);

    if (name) {
      name.textContent = getStockName(stock, langKey);
    }

    if (rate && yearData) {
      rate.textContent = yearData;
      updatePercentClass(rate, yearData);
    }
  }

  function hydrateHotLineText(element, stock, langKey) {
    if (!stock) return;
    var name = element.querySelector("b");
    var symbol = element.querySelector("em");

    if (name) {
      name.textContent = getStockName(stock, langKey);
    }

    if (symbol) {
      symbol.textContent = stock.symbol || "";
    }
  }

  function hydrateHotLineRate(element, stock) {
    if (!stock) return;
    var rate = element.querySelector("em");
    var yearData = getStockYearData(stock);

    if (rate && yearData) {
      rate.textContent = yearData;
      updatePercentClass(rate, yearData);
    }
  }

  function hydrateHeroCardRate(element, stock) {
    if (!stock) return;
    var yearData = getStockYearData(stock);

    if (yearData) {
      element.textContent = yearData;
      updatePercentClass(element, yearData);
    }
  }

  function hydrateHeroCardName(element, stock, langKey) {
    if (!stock) return;
    element.textContent = getStockName(stock, langKey);
  }

  function hydrateStockSections() {
    var langKey = getLangKey();

    stockPageData.forEach(function (stock) {
      stockMap[stock.symbol] = stock;
    });

    Array.prototype.forEach.call(document.querySelectorAll("[data-stock-summary]"), function (element) {
      hydrateStockSummary(element, stockMap[element.getAttribute("data-stock-summary")], langKey);
    });

    Array.prototype.forEach.call(document.querySelectorAll("[data-stock-line-text]"), function (element) {
      hydrateHotLineText(element, stockMap[element.getAttribute("data-stock-line-text")], langKey);
    });

    Array.prototype.forEach.call(document.querySelectorAll("[data-stock-line-rate]"), function (element) {
      hydrateHotLineRate(element, stockMap[element.getAttribute("data-stock-line-rate")]);
    });

    Array.prototype.forEach.call(document.querySelectorAll("[data-stock-card-rate]"), function (element) {
      hydrateHeroCardRate(element, stockMap[element.getAttribute("data-stock-card-rate")]);
    });

    Array.prototype.forEach.call(document.querySelectorAll("[data-stock-card-name]"), function (element) {
      hydrateHeroCardName(element, stockMap[element.getAttribute("data-stock-card-name")], langKey);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", hydrateStockSections);
  } else {
    hydrateStockSections();
  }
})();

(function () {
  function initMobileHeroTooltip() {
    var tipWrap = document.querySelector(".container1-tipWrap");
    if (!tipWrap) return;

    var mobileQuery = window.matchMedia("(max-width: 996px)");

    function closeTooltip() {
      tipWrap.classList.remove("is-open");
      tipWrap.setAttribute("aria-expanded", "false");
    }

    function toggleTooltip(event) {
      if (!mobileQuery.matches) return;
      if (event.target.closest(".container1-tooltipClose")) {
        event.preventDefault();
        event.stopPropagation();
        closeTooltip();
        return;
      }
      if (event.target.closest(".container1-tooltip")) return;

      event.preventDefault();
      event.stopPropagation();

      var isOpen = tipWrap.classList.toggle("is-open");
      tipWrap.setAttribute("aria-expanded", isOpen ? "true" : "false");
    }

    tipWrap.addEventListener("click", toggleTooltip);
    tipWrap.addEventListener("keydown", function (event) {
      if (!mobileQuery.matches) return;
      if (event.key === "Enter" || event.key === " ") {
        toggleTooltip(event);
      }
    });

    document.addEventListener("click", function (event) {
      if (!mobileQuery.matches || tipWrap.contains(event.target)) return;
      closeTooltip();
    });

    window.addEventListener("scroll", closeTooltip, { passive: true });
    window.addEventListener("resize", closeTooltip);
    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape") {
        closeTooltip();
      }
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initMobileHeroTooltip);
  } else {
    initMobileHeroTooltip();
  }
})();
(function () {
  function initShareRuleModal() {
    var triggers = document.querySelectorAll("[data-share-rule-trigger]");
    var source = document.querySelector(".container1-tooltip");
    var pageContainer = document.getElementById("pageContainer"); // 获取最外层容器

    if (!triggers.length || !source || !pageContainer) return;

    var modal;
    var dialog;
    var lastActiveElement;
    var vueScopeId = null;

    // 🌟 直接从 pageContainer 身上“偷” data-v 属性
    for (var i = 0; i < pageContainer.attributes.length; i++) {
      var attrName = pageContainer.attributes[i].name;
      if (attrName.indexOf("data-v-") === 0) {
        vueScopeId = attrName;
        break;
      }
    }

    // 给元素及子元素打标签的方法
    function applyScopeId(element) {
      if (!vueScopeId) return;
      element.setAttribute(vueScopeId, "");
      var children = element.querySelectorAll("*");
      Array.prototype.forEach.call(children, function (child) {
        child.setAttribute(vueScopeId, "");
      });
    }

    function buildModal() {
      if (modal) return modal;

      modal = document.createElement("div");
      modal.className = "shareRuleModal";
      modal.setAttribute("role", "dialog");
      modal.setAttribute("aria-modal", "true");

      dialog = document.createElement("div");
      dialog.className = "shareRuleModal-dialog";
      dialog.innerHTML = source.innerHTML;

      Array.prototype.forEach.call(dialog.querySelectorAll(".container1-tooltipClose"), function (button) {
        button.parentNode.removeChild(button);
      });

      var closeButton = document.createElement("button");
      closeButton.className = "shareRuleModal-close";
      closeButton.type = "button";
      closeButton.setAttribute("aria-label", "关闭");
      closeButton.addEventListener("click", closeModal);

      dialog.appendChild(closeButton);
      modal.appendChild(dialog);

      // 🌟 在 append 到 body 之前，给弹窗注入 scoped 标识
      applyScopeId(modal);

      document.body.appendChild(modal);

      modal.addEventListener("click", function (event) {
        if (event.target === modal) {
          closeModal();
        }
      });

      return modal;
    }

    // ... 下面的 openModal 和 closeModal 逻辑不变 ...
    function openModal() {
      lastActiveElement = document.activeElement;
      buildModal();
      modal.classList.add("is-open");
      document.documentElement.classList.add("shareRuleModal-open");
    }

    function closeModal() {
      if (!modal) return;
      modal.classList.remove("is-open");
      document.documentElement.classList.remove("shareRuleModal-open");
      if (lastActiveElement && typeof lastActiveElement.focus === "function") {
        lastActiveElement.focus();
      }
    }

    Array.prototype.forEach.call(triggers, function (trigger) {
      trigger.addEventListener("click", openModal);
    });

    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape" && modal && modal.classList.contains("is-open")) {
        closeModal();
      }
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initShareRuleModal);
  } else {
    initShareRuleModal();
  }
})();
        },
        initPage() {
            const setTabActIdx = (idx, e) => {
                scrollTabElement.forEach((item, index) => {
                    item.classList.remove("active");
                });
                floatTabElement.forEach((item, index) => {
                    item.classList.remove("active");
                });
                floatTabElement[idx].classList.add("active");
                scrollTabElement[idx].classList.add("active");
                const rem = parseFloat(getComputedStyle(document.documentElement).fontSize);
                const leftPad = 32 * rem;
                const wrapper = document.querySelector(".scrollTabWrapper");
                wrapper.scrollLeft = idx <= 1 ? 0 : e.target.offsetLeft - leftPad;
            };
            const scrollTabElement = document.querySelectorAll(
                ".scrollTabWrapper .tabItem"
            );
            const floatTabElement = document.querySelectorAll(".floatTab .tabItem");
            floatTabElement.forEach((item, idx) => {
                item.addEventListener("click", function (e) {
                    jumpPage(idx);
                });
            });
            scrollTabElement.forEach((item, idx) => {
                item.addEventListener("click", function (e) {
                    jumpPage(idx);
                });
            });
            let tabIndex = 0;

            if (location.href.includes("/commodity/")) {
                tabIndex = 1;
            } else if (location.href.includes("/index-cfds/")) {
                tabIndex = 2;
            } else if (location.href.includes("/share-cfds/")) {
                tabIndex = 3;
            } else if (location.href.includes("/etf/")) {
                tabIndex = 4;
            } else if (location.href.includes("/crypto/")) {
                tabIndex = 5;
            }
            setTabActIdx(tabIndex, { target: floatTabElement[tabIndex] });
            setTabActIdx(tabIndex, { target: scrollTabElement[tabIndex] });
            function jumpPage(idx) {
                const pathArr = location.pathname.split("/");
                const len = pathArr.length;
                const targetArr = ["forex", "commodity", "index-cfds", "share-cfds", "etf", 'crypto'];
                pathArr[len - 2] = targetArr[idx];
                location.href = pathArr.join("/");
            }
            // console.log(ProductVM, 1111)
            ProductVM.changeHandle(tabIndex);
            document.addEventListener("mountedSuccess", (e) => {
                ProductVM.changeHandle(tabIndex);
            });
            ; (function initShareHotModule() {
                const root = document.querySelector(".shareHotModule");
                if (!root) return;

                const END_ISO = "2026-09-12T00:00:00+03:00";
                const endMs = new Date(END_ISO).getTime();
                if (!Number.isFinite(endMs)) return;

                const $d = root.querySelector('[data-share-hot="days"]');
                const $h = root.querySelector('[data-share-hot="hours"]');
                const $m = root.querySelector('[data-share-hot="minutes"]');
                const $s = root.querySelector('[data-share-hot="seconds"]');

                const pad2 = (n) => String(n).padStart(2, "0");

                const tick = () => {
                    const diffMs = endMs - Date.now();
                    if (diffMs <= 0) {
                        root.style.display = "none";
                        return false;
                    }

                    const totalSec = Math.floor(diffMs / 1000);
                    const days = Math.floor(totalSec / 86400);
                    const hours = Math.floor((totalSec % 86400) / 3600);
                    const minutes = Math.floor((totalSec % 3600) / 60);
                    const seconds = totalSec % 60;

                    if ($d) $d.textContent = String(days);
                    if ($h) $h.textContent = pad2(hours);
                    if ($m) $m.textContent = pad2(minutes);
                    if ($s) $s.textContent = pad2(seconds);

                    return true;
                };

                if (!tick()) return;
                const timer = setInterval(() => {
                    if (!tick()) clearInterval(timer);
                }, 1000);
            })();

            ; (function initShareHotRuleModal() {
                const root = document.querySelector(".shareHotModule");
                if (!root) return;

                const trigger = root.querySelector("[data-share-hot-rule]");
                const modal = document.getElementById("shareHotRuleModal");
                if (!trigger || !modal) return;

                const dialog = modal.querySelector(".shareHotRuleModal-dialog");
                const closeEls = modal.querySelectorAll("[data-share-hot-rule-close]");

                const open = () => {
                    modal.classList.add("is-open");
                    modal.setAttribute("aria-hidden", "false");
                    setTimeout(() => dialog && dialog.focus(), 0);
                };
                const close = () => {
                    modal.classList.remove("is-open");
                    modal.setAttribute("aria-hidden", "true");
                };

                trigger.addEventListener("click", (e) => {
                    e.preventDefault();
                    open();
                });

                closeEls.forEach((el) => el.addEventListener("click", close));

                document.addEventListener("keydown", (e) => {
                    if (e.key === "Escape" && modal.classList.contains("is-open")) close();
                });
            })();


        }
    }
}

</script>
<style scoped lang="scss">
@import url("../assets/css/commonQuestion.scss");
#pageContainer .primary-default_large{
    align-items: center;
    background: var(--ebc-basecolor-active-500);
    border-radius: var(--ebc-corner-radius-full);
    color: var(--ebc-text-primary_white);
    display: flex;
    font-size: 16rem;
    font-style: normal;
    font-weight: 500;
    height: 48rem;
    justify-content: center;
    padding: 0 24rem;
    gap: 5rem;
    min-width: 140rem;
    line-height: 1;
}
#pageContainer .primary-default_large:hover{
    background: var(--ebc-basecolor-active-400);
}
.container1{
  position: relative;
  min-height: 738rem;
  padding: 160rem 0 80rem;
  box-sizing: border-box;
  background: var(--ebc-neutral-bg_b, #f7f7f7);
}
.container1 .container1Content {
  position: relative;
}
.container1 .left{
  position: relative;
  z-index: 2;
  width: 543rem;
}
.container1-copy{
  display: flex;
  flex-direction: column;
  gap: 24rem;
}
.container1 h1{
  margin: 0;
  font-size: 80rem;
  line-height: 88rem;
  font-weight: 700;
  color: var(--ebc-text-primary, #000);
  white-space: nowrap;
}
.container1-desc{
  color: var(--ebc-text-secondary, rgba(0,0,0,0.64));
}
.container1-desc p{
  margin: 0;
  line-height: 28rem;
}
.container1-offer{
  display: flex;
  align-items: center;
  color: var(--ebc-functional-active-normal, #a52933);
}
.container1-tipWrap{
  position: relative;
  display: inline-flex;
  align-items: center;
  margin-left: 4rem;
}
.container1-tipWrap::after{
  content: "";
  position: absolute;
  left: 100%;
  top: 50%;
  width: 20rem;
  height: 80rem;
  transform: translateY(-50%);
  display: none;
}
.container1-tipIcon{
  width: 18rem;
  height: 18rem;
  cursor: pointer;
}
.container1-tooltip{
  position: absolute;
  left: 100%;
  top: 50%;
  width: 500rem;
  box-sizing: border-box;
  padding: 28rem 43rem;
  border-radius: 21rem;
  background: var(--ebc-brand-neutral-deep_black, #232222);
  color: var(--ebc-text-secondary_white, rgba(255,255,255,0.64));
  font-size: 14rem;
  line-height: 22rem;
  opacity: 0;
  visibility: hidden;
  transform: translate(12rem, -50%);
  transition: opacity .2s ease, transform .2s ease, visibility .2s ease;
  pointer-events: auto;
}
.container1-tooltip::before{
  content: "";
  position: absolute;
  left: -8rem;
  top: 50%;
  width: 0;
  height: 0;
  border-top: 10rem solid transparent;
  border-bottom: 10rem solid transparent;
  border-right: 10rem solid var(--ebc-brand-neutral-deep_black, #232222);
  transform: translateY(-50%);
}
.container1-tooltip strong{
  display: block;
  margin-bottom: 16rem;
  color: var(--ebc-brand-neutral-beige, #f9f6f2);
  font-size: 24rem;
  line-height: 32rem;
  font-weight: 700;
}
.container1-tooltip span{
  display: block;
}
.container1-tooltip span + span{
  margin-top: 14rem;
}
.container1-tooltip span span:last-child{
  margin-top: 6rem;
}
.container1-tooltip b{
  display: block;
  color: var(--ebc-text-primary_white, #fff);
  font-weight: 500;
}
.container1-tooltipClose{
  display: none;
}
.container1-tipWrap:hover .container1-tooltip,
.container1-tipWrap:focus-within .container1-tooltip{
  opacity: 1;
  visibility: visible;
}
.container1-tipWrap:hover::after,
.container1-tipWrap:focus-within::after{
  display: block;
}
.container1-tags{
  display: flex;
  gap: 8rem;
  color: var(--ebc-text-primary, #000);
}
.container1-tags span{
  display: inline-flex;
  align-items: center;
  gap: 8rem;
  padding: 4rem 8rem;
  border-radius: var(--ebc-corner-radius-rc08, 8rem);
  background: var(--ebc-neutral-bg_a, #fff);
  white-space: nowrap;
}
.container1-tags img{
  width: 12rem;
  height: 12rem;
}
.container1-actions{
  display: flex;
  align-items: center;
  gap: 16rem;
  margin-top: 64rem;
}
.container1-actions a{
  text-decoration: none;
}
#pageContainer .btn{
  min-width: 140rem;
}
#pageContainer  .container1-outlineBtn{
  box-sizing: border-box;
  height: 48rem;
  padding: 10rem 24rem;
  border: 1rem solid var(--ebc-functional-active-normal, #a52933);
  border-radius: var(--ebc-corner-radius-full, 999rem);
  background: transparent;
  color: var(--ebc-functional-active-normal, #a52933);
  min-width: 120rem;
  text-align: center;
}
#pageContainer  .container1-outlineBtn:hover{
  border: 1rem solid var(--ebc-basecolor-active-400);
  color: var(--ebc-basecolor-active-400);

}
.container1 .right{
  position: absolute;
  top: -80rem;
  right: 0;
  z-index: 1;
  display: flex;
  gap: 20rem;
  width: 476rem;
  height: 658rem;
  overflow: hidden;
  pointer-events: none;
  visibility: hidden;
}
.container1 .right.is-ready{
  visibility: visible;
}
.container1-carouselCol{
  width: 228rem;
  overflow: hidden;
}
.container1-carouselTrack{
  display: flex;
  flex-direction: column;
  gap: 20rem;
  animation: none;
  will-change: transform;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
}
.container1-carouselTrackDown{
  transform: translateY(-1836rem);
}
.container1 .right.is-ready .container1-carouselTrack{
  animation: shareCfdsHeroUp 48s linear infinite;
}
.container1 .right.is-ready .container1-carouselTrackDown{
  animation-name: shareCfdsHeroDown;
}
.container1-card{
  position: relative;
  flex: 0 0 auto;
  width: 228rem;
  height: 286rem;
  overflow: hidden;
    isolation: isolate;
  border-radius: var(--ebc-corner-radius-rc16, 16rem);
  background: var(--ebc-brand-neutral-light_gold, #b2afad);
  transform: translateZ(0);
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
}
.container1-cardMedia{
    position: relative;
  z-index: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  transform: translateZ(0);
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
}
.container1-card::after{
  content: "";
   z-index: 1;
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 102rem;
  background: linear-gradient(180deg, rgba(255,255,255,0) 0%, rgba(0,0,0,.9) 100%);
  mix-blend-mode: multiply;
}
.container1-cardInfo{
  position: absolute;
  left: 18rem;
  bottom: 20rem;
  z-index: 3;
  display: flex;
  align-items: center;
  gap: 11rem;
  transform: translateZ(0);
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
}
.container1-cardLogo{
  width: 46rem;
  height: 46rem;
  display: flex;
  align-items: center;
  justify-content: center;
}
.container1-cardLogo img{
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.container1-cardName{
  display: block;
  color: var(--ebc-text-primary_white, #fff);
  font-size: 16rem;
  line-height: 20rem;
  font-weight: 500;
  white-space: nowrap;
}
.container1-cardRate{
  display: block;
  margin-top: 8rem;
  color: #00b181;
  font-size: 20rem;
  line-height: 20rem;
  font-weight: 700;
  white-space: nowrap;
}
.container1-cardRate.is-negative{
  color: #e60004;
}
@keyframes shareCfdsHeroUp {
  from {
    transform: translateY(0);
  }
  to {
    transform: translateY(-1836rem);
  }
}
@keyframes shareCfdsHeroDown {
  from {
    transform: translateY(-1836rem);
  }
  to {
    transform: translateY(0);
  }
}
@media (min-width: 996px) {
  .ug .container1 h1,
  .es .container1 h1{
    white-space: nowrap;
  }
  .ar .container1 .right{
    right: auto;
    left: 0;
  }
  .ar .container1-tooltip{
    left: auto;
    right: 50%;
    transform: translate(50%, -8rem);
  }
  .ar .container1-tipWrap::after{
    left: auto;
    right: 100%;
  }
  .ar .container1-tipWrap:hover .container1-tooltip,
  .ar .container1-tipWrap:focus-within .container1-tooltip{
    transform: translate(50%, 0);
  }
  .mn .container1 h1{
    font-size: 60rem;
    white-space: nowrap;
    line-height: 68rem;
  }
}
@media (max-width: 996px) {
  .container1 {
    /* min-height: 1448rem; */
    padding: 0rem 32rem 80rem;
    overflow: hidden;
    background: var(--ebc-neutral-bg_c, #f2f2f2);
    z-index: 999;
  }
  .container1 .container1Content{
    width: 100%;
  }
  .container1 .left{
    width: 100%;
    padding-top: 644rem;
    text-align: center;
  }
  .container1-copy{
    align-items: center;
    gap: 16rem;
  }
  .container1 h1{
    font-size: 64rem;
    line-height: 80rem;
    white-space: normal;
  }
  .container1-desc{
    width: 538rem;
    max-width: 100%;
  }
  .container1-desc p{
    line-height: 44rem;
  }
  .container1-offer{
    justify-content: center;
    white-space: nowrap;
  }
  .container1-tipIcon{
    width: 24rem;
    height: 24rem;
  }
  .container1-tooltip{
    position: fixed;
    left: 0;
    right: 0;
    top: auto;
    bottom: 0;
    z-index: 1200;
    width: 100vw;
    max-width: none;
    max-height: 72vh;
    overflow-y: auto;
    padding: 56rem 48rem 72rem;
    border-radius: 32rem 32rem 0 0;
    font-size: 28rem;
    line-height: 44rem;
    transform: translateY(100%);
    transition: opacity .24s ease, transform .24s ease, visibility .24s ease;
    pointer-events: auto;
  }
  .container1-tooltip::before{
    display: none;
  }
  .container1-tooltip strong{
    margin-bottom: 32rem;
    font-size: 48rem;
    line-height: 64rem;
  }
  .container1-tooltip span{
    display: block;
    width: 100%;
    white-space: pre-wrap;
    text-align: left;
  }
  .container1-tooltipClose{
    position: absolute;
    top: 24rem;
    right: 24rem;
    display: block;
    width: 56rem;
    height: 56rem;
    padding: 0;
    border: 0;
    border-radius: 50%;
    background: rgba(255,255,255,0.12);
    color: var(--ebc-text-primary_white, #fff);
  }
  .container1-tooltipClose::before,
  .container1-tooltipClose::after{
    content: "";
    position: absolute;
    left: 14rem;
    top: 27rem;
    width: 28rem;
    height: 3rem;
    background: currentColor;
  }
  .container1-tooltipClose::before{
    transform: rotate(45deg);
  }
  .container1-tooltipClose::after{
    transform: rotate(-45deg);
  }
  .container1-tooltip span + span{
    margin-top: 28rem;
  }
  .container1-tipWrap:hover .container1-tooltip,
  .container1-tipWrap:focus-within .container1-tooltip{
    opacity: 0;
    visibility: hidden;
    transform: translateY(100%);
  }
  .container1-tipWrap.is-open .container1-tooltip{
    opacity: 1;
    visibility: visible;
    transform: translateY(0);
  }
  .container1-tags{
    gap: 16rem;
    flex-wrap: wrap;
    justify-content: center;
  }
  .container1-tags span{
    gap: 8rem;
    padding: 4rem 8rem;
    border-radius: 8rem;
  }
  .container1-tags img{
    width: 12rem;
    height: 12rem;
  }
  .container1-actions{
    justify-content: center;
    gap: 24rem;
    margin-top: 64rem;
  }
  #pageContainer .container1-actions .btn{
    width: 686rem;
    height: 96rem;
    min-width: 0;
    box-sizing: border-box;
    padding: 20rem 48rem;
    border-radius: var(--ebc-corner-radius-full, 999rem);
    font-size: 32rem;
    line-height: 56rem;
  }
  .container1-outlineBtn{
    height: 80rem;
    padding: 18rem 40rem;
    border-width: 2rem;
  }
  .container1 .right{
    top: 0;
    left: 50%;
    width: 686rem;
    height: 612rem;
    gap: 28.824rem;
    transform: translateX(-50%);
    transform-origin: top left;
  }
  .container1-carouselCol{
    width: 328.588rem;
  }
  .container1-carouselTrack{
    gap: 28.824rem;
  }
  .container1-carouselTrackDown{
    transform: translateY(-2641.056rem);
  }
  .container1 .right.is-ready .container1-carouselTrack{
    animation-name: shareCfdsHeroUpMobile;
  }
  .container1 .right.is-ready .container1-carouselTrackDown{
    animation-name: shareCfdsHeroDownMobile;
  }
  .container1-card{
    width: 328.588rem;
    height: 412.176rem;
    border-radius: 23.058rem;
  }
  .container1-card::after{
    height: 147rem;
  }
  .container1-cardInfo{
    left: 26.24rem;
    bottom: 26.24rem;
    gap: 16.402rem;
  }
  .container1-cardLogo{
    width: 65.608rem;
    height: 65.608rem;
  }
  .container1-cardName{
    font-size: 22.962rem;
    line-height: 26rem;
  }
  .container1-cardRate{
    margin-top: 16.402rem;
    font-size: 28.824rem;
    line-height: 29rem;
  }
}
@keyframes shareCfdsHeroUpMobile {
  from {
    transform: translateY(0);
  }
  to {
    transform: translateY(-2641.056rem);
  }
}
@keyframes shareCfdsHeroDownMobile {
  from {
    transform: translateY(-2641.056rem);
  }
  to {
    transform: translateY(0);
  }
}

/* shareAiCore */
.shareAiCore{
  padding: 60rem 0 120rem;
  background: var(--ebc-neutral-bg_a, #fff);
}
.shareAiCore-head{
  width: 1200rem;
  margin: 0 auto 60rem;
  text-align: center;
}
.shareAiCore-head h2,
.shareAiCore-head p{
  margin: 0;
}
.shareAiCore-head h2{
  color: var(--ebc-text-primary, #000);
}
.shareAiCore-head p{
  margin-top: 16rem;
  color: var(--ebc-text-secondary, rgba(0,0,0,0.64));
}
.shareAiCore-layout{
  display: flex;
  align-items: stretch;
  gap: 20rem;
  width: 1200rem;
}
.shareAiCore-leftCard{
  position: relative;
  width: 500rem;
  min-height: 646rem;
  overflow: hidden;
  border-radius: var(--ebc-corner-radius-rc24, 24rem);
  background: var(--ebc-neutral-bg_b, #f7f7f7);
}

.shareAiCore-picture{
  position: absolute;
  inset: 0;
  top: 145rem;
  width: 100%;
  display: block;
}
.shareAiCore-leftImg{
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: top;
}
.shareAiCore-leftText{
  position: absolute;
  top: 32rem;
  left: 40rem;
  z-index: 2;
  width: 430rem;
  max-width: calc(100% - 64rem);
  color: var(--ebc-text-primary, #000);
  overflow-wrap: anywhere;
}
.shareAiCore-leftText p,
.shareAiCore-leftText h3{
  margin: 0;
}
.shareAiCore-leftText h3{
  margin-top: 4rem;
}
.shareAiCore-btn{
  margin: 37rem 0 0!important;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 48rem;
  box-sizing: border-box;
  padding: 10rem 40rem;
  border-radius: var(--ebc-corner-radius-full, 999rem);
  background: var(--ebc-functional-active-normal, #a52933);
  color: var(--ebc-text-primary_white, #fff);
  text-decoration: none;
  white-space: nowrap;
  line-height: 30rem!important
}
.shareAiCore-btn:hover{
  background: var(--ebc-basecolor-active-400, #bb3841);
  color: var(--ebc-text-primary_white, #fff);
}
.shareAiCore-cardList{
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 20rem;
  min-width: 0;
}
.shareAiCore-card{
  width: 100%;
  box-sizing: border-box;
  padding: 32rem 40rem;
  border-radius: var(--ebc-corner-radius-rc24, 24rem);
  background: var(--ebc-neutral-bg_b, #f7f7f7);
  transition: box-shadow .24s ease, transform .24s ease;
}
.shareAiCore-card:hover{
  box-shadow: 10rem 10rem 32rem 0 rgba(0,0,0,0.2);
  transform: translateY(-2rem);
}
.shareAiCore-cardTop{
  display: flex;
  flex-direction: column;
  gap: 12rem;
}
.shareAiCore-cardTop h3{
  margin: 0;
  color: var(--ebc-text-primary, #000);
}
.shareAiCore-tags{
  display: flex;
  flex-wrap: wrap;
  gap: 4rem;
}
.shareAiCore-tags span{
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 22rem;
  box-sizing: border-box;
  padding: 4rem 8rem;
  border: 1rem solid var(--ebc-neutral-stroke, rgba(0,0,0,0.12));
  border-radius: 5rem;
  background: var(--ebc-neutral-bg_a, #fff);
  color: var(--ebc-text-secondary, rgba(0,0,0,0.64));
  font-size: 12rem;
  line-height: 13rem;
  white-space: nowrap;
}
.shareAiCore-card:hover .shareAiCore-tags span{
  border-color: var(--ebc-functional-active-normal, #a52933);
  color: var(--ebc-functional-active-normal, #a52933);
}
.shareAiCore-stocks{
  display: flex;
  align-items: center;
  gap: 40rem;
  margin-top: 28rem;
  flex-wrap: wrap;
}
.shareAiCore-stock{
  display: inline-flex;
  align-items: center;
  gap: 12rem;
}
.shareAiCore-logo{
  width: 48rem;
  height: 48rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}
.shareAiCore-logo img{
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.shareAiCore-stock b,
.shareAiCore-stock em{
  display: block;
  font-size: 16rem;
  line-height: 18rem;
  white-space: nowrap;
}
.shareAiCore-stock b{
  color: var(--ebc-text-primary, #000);
  font-weight: 500;
}
.shareAiCore-stock em{
  margin-top: 10rem;
  color: #00b181;
  font-style: normal;
  font-weight: 700;
}
.shareAiCore-stock em.is-negative{
  color: #e60004;
}
@media (max-width: 996px) {
  .shareAiCore{
    display: block;
    padding: 80rem 32rem 160rem;
  }
  .shareAiCore .contentBox{
    width: 100%;
  }
  .shareAiCore-head{
    width: 686rem;
    max-width: 100%;
    margin: 0 auto 80rem;
  }
  .shareAiCore-head h2{
    font-size: 48rem;
    line-height: 64rem;
  }
  .shareAiCore-head p{
    width: 672rem;
    max-width: 100%;
    margin: 16rem auto 0;
    font-size: 24rem;
    line-height: 40rem;
  }
  .shareAiCore-layout{
    width: 686rem;
    max-width: 100%;
    flex-direction: column;
    gap: 32rem;
  }
  .shareAiCore-leftCard{
    width: 100%;
    min-height: 770rem;
    border-radius: 16rem;
  }
  .shareAiCore-leftCard::before,
  .shareAiCore-leftCard::after{
    display: none;
  }
  .shareAiCore-picture,
  .shareAiCore-leftImg{
    min-height: 650rem;
  }
 .shareAiCore-leftText{
    top: 40rem;
    left: 32rem;
    width: 610rem;
    max-width: calc(100% - 64rem);
  }
  .shareAiCore-leftText p{
    font-size: 32rem;
    line-height: 44rem;
    color: var(--ebc-text-secondary, rgba(0,0,0,0.64));
  }
  .shareAiCore-leftText h3{
    margin-top: 16rem;
    font-size: 64rem;
    line-height: 1;
  }
  .shareAiCore-btn{
    height: 80rem;
    bottom: 64rem;
    padding: 16rem 48rem;
    font-size: 28rem;
    line-height: 48rem!important;
    margin-top: 64rem;
  }
  .shareAiCore-cardList{
    width: 100%;
    gap: 32rem;
  }
  .shareAiCore-card{
    padding: 40rem 32rem;
    border-radius: 16rem;
  }
  .shareAiCore-card:hover{
    box-shadow: none;
    transform: none;
  }
  .shareAiCore-cardTop{
    gap: 16rem;
  }
  .shareAiCore-cardTop h3{
    font-size: 32rem;
    line-height: 48rem;
    font-weight: 500;
  }
  .shareAiCore-tags{
    gap: 8rem;
  }
  .shareAiCore-tags span{
    height: 44rem;
    padding: 8rem 16rem;
    border-radius: 9.334rem;
    font-size: 24rem;
    line-height: 26rem;
  }
  .shareAiCore-stocks{
    flex-wrap: wrap;
    gap: 40rem 80rem;
    margin-top: 48rem;
  }
  .shareAiCore-stock{
    gap: 16rem;
  }
  .shareAiCore-logo{
    width: 80rem;
    height: 80rem;
  }
  .shareAiCore-stock b,
  .shareAiCore-stock em{
    font-size: 28rem;
    line-height: 32rem;
  }
  .shareAiCore-stock em{
    margin-top: 20rem;
  }
}

/* shareHotLines */
.shareHotLines{
  padding: 120rem 0;
  background: linear-gradient(180deg, #16161a 0%, #2b2b33 100%);
}
.shareHotLines-head{
  width: 1200rem;
  margin: 0 auto 60rem;
  text-align: center;
}
.shareHotLines-head h2,
.shareHotLines-head p{
  margin: 0;
}
.shareHotLines-head h2{
  color: var(--ebc-text-primary_white, #fff);
}
.shareHotLines-head p{
  margin-top: 16rem;
  color: rgba(255,255,255,0.8);
}
.shareHotLines-grid{
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 20rem;
  width: 1200rem;
}
.shareHotLines-card{
  box-sizing: border-box;
  min-width: 0;
  padding: 32rem;
  border-radius: var(--ebc-corner-radius-rc24, 24rem);
  background: rgba(255,255,255,0.05);
  transition: background .24s ease, transform .24s ease;
}
.shareHotLines-card.is-active,
.shareHotLines-card:hover{
  background: #3b3b42;
}
.shareHotLines-card:hover{
  transform: translateY(-2rem);
}
.shareHotLines-card h3{
  margin: 0;
  color: var(--ebc-text-primary_white, #fff);
}
.shareHotLines-list{
  display: flex;
  flex-direction: column;
  gap: 32rem;
  margin-top: 32rem;
}
.shareHotLines-stock{
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12rem;
}
.shareHotLines-logo{
  flex: 0 0 auto;
  width: 48rem;
  height: 48rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}
.shareHotLines-logo img{
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.shareHotLines-stockText{
  flex: 1;
  min-width: 0;
}
#pageContainer em{
  font-style: normal!important;
}
.shareHotLines-stockText b,
.shareHotLines-stockText em,
.shareHotLines-rate b,
.shareHotLines-rate em{
  display: block;
  white-space: nowrap;
}
.shareHotLines-stockText b{
  color: var(--ebc-text-primary_white, #fff);
  font-size: 16rem;
  line-height: 18rem;
  font-weight: 500;
}
.shareHotLines-stockText em{
  margin-top: 10rem;
  color: var(--ebc-text-secondary_white, rgba(255,255,255,0.64));
  font-size: 14rem;
  line-height: 16rem;
  font-style: normal;
  font-weight: 400;
}
.shareHotLines-rate{
  flex: 0 0 auto;
  text-align: right;
}
.shareHotLines-rate b{
  color: var(--ebc-text-primary_white, #fff);
  font-size: 14rem;
  line-height: 1;
  font-weight: 400;
}
.shareHotLines-rate em{
  margin-top: 10rem;
  color: #00d89e;
  font-size: 18rem;
  line-height: 26rem;
  font-style: normal;
  font-weight: 700;
}
.shareHotLines-rate em.is-negative{
  color: #e60004;
}
.contentBox{
    max-width: 1200rem;
    margin-inline:auto;
  }
@media (max-width: 996px) {
  .shareHotLines{
    display: block;
    padding: 160rem 0;
  }
  .shareHotLines .contentBox{
    width: 100%;
  }
  .shareHotLines-head{
    width: 686rem;
    max-width: calc(100% - 64rem);
    margin: 0 auto 80rem;
  }
  .shareHotLines-head h2{
    font-size: 48rem;
    line-height: 64rem;
  }
  .shareHotLines-head p{
    margin-top: 16rem;
    font-size: 24rem;
    line-height: 40rem;
    color: var(--ebc-text-secondary_white, rgba(255,255,255,0.64));
  }
  .shareHotLines-grid{
    display: flex;
    grid-template-columns: none;
    gap: 40rem;
    width: 100%;
    box-sizing: border-box;
    padding: 0 32rem;
    overflow-x: auto;
    overflow-y: hidden;
    scroll-snap-type: x mandatory;
    scrollbar-width: none;
    -ms-overflow-style: none;
  }
  .shareHotLines-grid::-webkit-scrollbar{
    display: none;
  }
  .shareHotLines-card{
    flex: 0 0 600rem;
    width: 600rem;
    padding: 46rem;
    border-radius: 24rem;
    background: #303037;
    scroll-snap-align: center;
  }
  .shareHotLines-card.is-active,
  .shareHotLines-card:hover{
    background: #303037;
  }
  .shareHotLines-card:hover{
    transform: none;
  }
  .shareHotLines-card h3{
    font-size: 32rem;
    line-height: 48rem;
    font-weight: 500;
  }
  .shareHotLines-list{
    gap: 48rem;
    margin-top: 48rem;
  }
  .shareHotLines-stock{
    gap: 24rem;
  }
  .shareHotLines-logo{
    width: 80rem;
    height: 80rem;
  }
  .shareHotLines-stockText b{
    font-size: 28rem;
    line-height: 32rem;
  }
  .shareHotLines-stockText em{
    margin-top: 20rem;
    font-size: 24rem;
    line-height: 28rem;
  }
  .shareHotLines-rate b{
    font-size: 24rem;
    line-height: 44rem;
  }
  .shareHotLines-rate em{
    margin-top: 20rem;
    font-size: 28rem;
    line-height: 52rem;
  }
}
.container2{
  margin-top: 0;
}
.container2 h3{
  margin:16rem 0 60rem;
}
.container2 .contentBox {
  padding-top: 160rem;
}
.shareTradingHours{
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16rem;
  box-sizing: border-box;
  width: 100%;
  margin: 50rem 0 20rem;
  padding: 20rem 32rem;
  border-radius: var(--ebc-corner-radius-rc12, 12rem);
  background: #fcf9f5;
  color: var(--ebc-text-secondary, rgba(0,0,0,0.64));
  line-height: 24rem;
}
.shareTradingHours-label{
  display: inline-flex;
  align-items: center;
  gap: 10rem;
  white-space: nowrap;
}
.shareTradingHours-label img{
  width: 20rem;
  height: 20rem;
}
.shareTradingHours-divider{
  width: 1rem;
  height: 20rem;
  background: rgba(0,0,0,0.12);
}
.shareTradingHours-text{
  display: inline-flex;
  align-items: flex-start;
  white-space: nowrap;
  flex-direction: column;
}
.shareTradingHours-text strong{
  color: var(--ebc-text-primary, #000);
  font-weight: 400;
}

.container2 .topCardList {
  margin-bottom:120rem;
  gap:24rem;
  align-items: stretch;
}

.container2 .topCardList .card {
  flex:1;
  border-radius: var(--ebc-corner-radius-rc16);
  background: var(--ebc-neutral-bg_b);
  padding:32rem 24rem;
  border:0;
}
.container2 .topCardList .card:nth-child(2){
  display: none;
}
.container2 .topCardList .card h3{
  margin:16rem 0;
  color: var(--ebc-text-primary);
}

.container2 .topCardList .card div{
  color: var(--ebc-text-secondary);
}
.container2 .jyBtn{
  margin-bottom: 60rem;
  min-width: 180rem;
}
@media (max-width: 996px) {
  .shareTradingHours{
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    gap: 24rem;
    margin: 80rem 0;
    padding: 40rem 32rem;
    border-radius: 24rem;
    font-size: 32rem;
    line-height: 48rem;
  }
  .shareTradingHours-label{
    gap: 20rem;
  }
  .shareTradingHours-label img{
    width: 40rem;
    height: 40rem;
  }
  .shareTradingHours-divider{
    display: none;
  }
  .shareTradingHours-text{
    display: flex;
    flex-direction: column;
    gap: 24rem;
    white-space: normal;
  }
  .shareTradingHours-text div{
    line-height: 48rem;
  }
  .shareTradingHours-text strong,
  .shareTradingHours-text span{
    display: block;
  }
  .shareTradingHours-text strong{
    color: var(--ebc-text-primary, #000);
  }
      .container2  {
        padding: 0rem 32rem 160rem;
    }
  .container2 .jyBtn{
    height: 80rem;
  margin-bottom: 80rem;
  min-width: unset;
  font-size: 28rem;
  line-height: 44rem;
  font-weight: 500;
}
  .container2 .topCardList{
    margin-bottom: 160rem;

      gap: 32rem;
      flex-wrap: wrap;
  }
  .container2 .topCardList .card h3{
  margin:0rem 0 8rem;
  color: var(--ebc-text-primary);
}
.container2 .topCardList .card {
  padding:32rem;
  padding-left: 128rem;
  flex:1 0 100%;
  position: relative;
}
.container2 .topCardList .card svg{
  position: absolute;
  left: 32rem;
  top: 50%;
  transform: translateY(-50%);
  width: 64rem;
  height: 64rem;
}
}

.product-table-tr>div:nth-child(4),
.product-table-th>div:nth-child(4){
  display: none!important;
}

/* shareHotModule */
.shareHotModule{
  position: relative;
  overflow: hidden;
  padding: 120rem 0 88rem;
}
.shareHotModule-bg{
  position: absolute;
  inset: 0;
  z-index: 0;
}
.shareHotModule-bg img{
  width: 100%;
  height: 100%;
  object-fit: cover;
  pointer-events: none;
}

.shareHotModule-content{
  position: relative;
  z-index: 2;
  text-align: center;
}
.shareHotModule-title{
  color: var(--ebc-text-primary_white, #fff);
}
.shareHotModule-benefits{
  margin-top: 28rem;
  color: var(--ebc-text-primary_white, #fff);
  font-weight: 700;
}
.shareHotModule-benefit:last-child {
  margin-left: 28.778rem;
}
.ar .shareHotModule-benefit:last-child{
    margin-left: 0;

  margin-right: 28rem;
}
.shareHotModule-benefitNum{
  color: var(--ebc-brand-accent-coral, #ff4b4e);
  font-size: 80rem;
  line-height: 80.579rem;
  margin-right: 4rem;
  
}
@media (min-width: 996px) {
.shareHotModule{
margin-top: -64rem;
}
  .shareHotModule-benefitNum,
  .shareHotModule-benefitText{
    height: 80rem;
    display: inline-block;
    vertical-align: bottom
  }
}
.shareHotModule-benefitText{
  font-size: 64rem;
  line-height: 80.579rem;
}
.shareHotModule-countdown{
  margin-top: 60rem;
}
.shareHotModule-countdownLabel{
  color: var(--ebc-text-primary_white, #fff);
}
.shareHotModule-countdownRow{
  margin-top: 12rem;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 14rem;
}
.shareHotModule-timeBox{
  width: 100rem;
  height: 100rem;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 14rem;
  background: rgba(255,255,255,0.1);
}
.shareHotModule-timeBox span{
  font-size: 40rem;
  line-height: 48rem;
  font-weight: 700;
  color: var(--ebc-text-primary_white, #fff);
}
.shareHotModule-unit{
  font-size: 24rem;
  line-height: 32rem;
  color: var(--ebc-text-primary_white, #fff);
}
.shareHotModule-ruleLink{
  margin-top: 60rem;
  display: inline-flex;
  align-items: center;
  color: var(--ebc-text-secondary_white, rgba(255,255,255,0.64));
  text-decoration: none;
}
.shareHotModule-ruleIcon{
  display: inline-block;
  margin-left: 4rem;
  transform: translateY(4rem);
}
.shareRuleLink{
  display: inline;
  padding: 0;
  border: 0;
  background: transparent;
  color: var(--ebc-functional-active-normal, #a52933);
  font: inherit;
  line-height: inherit;
  cursor: pointer;
}
.shareRuleLink:hover{
  color: var(--ebc-basecolor-active-400, #bb3841);
}
.shareRuleModal{
  position: fixed;
  inset: 0;
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  padding: 32rem;
  background: rgba(0,0,0,0.48);
  opacity: 0;
  visibility: hidden;
  transition: opacity .2s ease, visibility .2s ease;
}
.shareRuleModal.is-open{
  opacity: 1;
  visibility: visible;
}
.shareRuleModal-dialog{
  position: relative;
  width: 600rem;
  max-width: 100%;
  max-height: 78vh;
  box-sizing: border-box;
  overflow-y: auto;
  padding: 40rem 48rem;
  border-radius: 24rem;
  background: var(--ebc-brand-neutral-deep_black, #232222);
  color: var(--ebc-text-secondary_white, rgba(255,255,255,0.64));
  font-size: 16rem;
  line-height: 26rem;
}
.shareRuleModal-dialog strong{
  display: block;
  margin-bottom: 20rem;
  color: var(--ebc-brand-neutral-beige, #f9f6f2);
  font-size: 28rem;
  line-height: 36rem;
}
.shareRuleModal-dialog span{
  display: block;
}
.shareRuleModal-dialog span + span{
  margin-top: 16rem;
}
.shareRuleModal-dialog b{
  display: block;
  color: var(--ebc-text-primary_white, #fff);
  font-weight: 500;
}
.shareRuleModal-close{
  position: absolute;
  top: 16rem;
  right: 16rem;
  width: 32rem;
  height: 32rem;
  border: 0;
  border-radius: 50%;
  background: rgba(255,255,255,0.12);
  color: var(--ebc-text-primary_white, #fff);
  cursor: pointer;
}
.shareRuleModal-close::before,
.shareRuleModal-close::after{
  content: "";
  position: absolute;
  left: 8rem;
  top: 15rem;
  width: 16rem;
  height: 2rem;
  background: currentColor;
}
.shareRuleModal-close::before{
  transform: rotate(45deg);
}
.shareRuleModal-close::after{
  transform: rotate(-45deg);
}
.shareRuleModal-open{
  overflow: hidden;
}
@media (max-width: 996px) {
    .shareRuleModal{
    align-items: flex-end;
    padding: 0;
  }
  .shareRuleModal-dialog{
    width: 100%;
    max-height: 72vh;
    padding: 56rem 48rem 72rem;
    border-radius: 32rem 32rem 0 0;
    font-size: 28rem;
    line-height: 44rem;
  }
  .shareRuleModal-dialog strong{
    margin-bottom: 32rem;
    font-size: 48rem;
    line-height: 64rem;
  }
  .shareRuleModal-dialog span{
    white-space: pre-wrap;
  }
  .shareRuleModal-dialog span + span{
    margin-top: 28rem;
  }
  .shareRuleModal-close{
    top: 24rem;
    right: 24rem;
    width: 56rem;
    height: 56rem;
  }
  .shareRuleModal-close::before,
  .shareRuleModal-close::after{
    left: 14rem;
    top: 27rem;
    width: 28rem;
    height: 3rem;
  }
  .shareHotModule{
    padding: 160rem 32rem;
    box-sizing: border-box;
    max-width: 100%;
  }
  .shareHotModule-benefits{
    margin-top: 20rem;
    line-height: normal;
  }
  .shareHotModule-benefit:last-child{
    margin-left: 24rem;
  }
   .vi .shareHotModule-benefit:last-child{
    margin-left: 0;
  }
  .ar .shareHotModule-benefit:last-child{
    margin-left: 0;
  margin-right: 24rem;
}
  .shareHotModule-benefitNum{
    font-size: 72rem;
    line-height: 90.804rem;
    margin-right: 4rem;
  }
  .shareHotModule-benefitText{
    font-size: 64rem;
    line-height: normal;
  }
  .shareHotModule-countdown{
    margin-top: 80rem;
  }
  .shareHotModule-countdownRow{
    gap: 12rem;
    margin-top: 24rem;
  }
  .shareHotModule-timeBox{
    width: 96rem;
    height: 96rem;
    border-radius: 14.406rem;
  }
  .shareHotModule-timeBox span{
    font-size: 36rem;
    line-height: 52rem;
  }
  .shareHotModule-unit{
    font-size: 28rem;
    line-height: 44rem;
  }
  .shareHotModule-ruleIcon{
    transform: translateY(6rem);
  }
  .shareHotModule-ruleLink{
    margin-top: 80rem;
  }
}

/* shareHotRuleModal */
.body-no-scroll{
  overflow: hidden;
  position: fixed;
  width: 100%;
}
.shareHotRuleModal{
  display: none;
  position: fixed;
  inset: 0;
  z-index: 999999999;
}
.shareHotRuleModal.is-open{
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 32rem;
}
.shareHotRuleModal-bg{
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.64);
}
.shareHotRuleModal-dialog{
  position: relative;
  width: 840rem;
  max-width: calc(100vw - 64rem);
  box-sizing: border-box;
  background: #fff;
  border: 1rem solid rgba(255,255,255,0.2);
  border-radius: var(--ebc-corner-radius-rc16, 16rem);
  box-shadow: 20rem 40rem 60rem 0 rgba(0,0,0,0.1);
  padding: 32rem;
  overflow: hidden;
}
.shareHotRuleModal-title{
  color: var(--ebc-text-primary, #000);
}
.shareHotRuleModal-close{
  position: absolute;
  top: 32rem;
  right: 32rem;
  width: 32rem;
  height: 32rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 0;
  padding: 0;
  background: transparent;
  cursor: pointer;
  color: rgba(0,0,0,0.48);
}
 .ar .shareHotRuleModal-close{
    right: unset;
    left: 32rem;
  }
.shareHotRuleModal-close .icon-close{
  font-size: 24rem;
}
.shareHotRuleModal-body{
  margin-top: 32rem;
}
.shareHotRuleModal-item + .shareHotRuleModal-item{
  margin-top: 20rem;
}
.shareHotRuleModal-itemTitle{
  color: var(--ebc-text-primary, #000);
  line-height: 24rem;
}
.shareHotRuleModal-itemText{
  margin-top: 4rem;
  color: var(--ebc-text-secondary, rgba(0,0,0,0.64));
  line-height: 22rem;
}
.shareHotRuleModal-itemText p{
  margin: 0;
}
.shareHotRuleModal-itemText p + p{
  margin-top: 4rem;
}

@media (max-width: 996px) {
  .scrollTabWrapper{
    width: 100%;
    box-sizing: border-box;
    padding-block: 30rem;
    margin-top: 0;
    background: var(--ebc-neutral-bg_c);
  }
  .scrollTab .tabItem{
    background: var(--ebc-neutral-bg_a);
  }
  .scrollTab .tabItem.active{
    background: var(--ebc-basecolor-active-500);
  }
  /* 移动端 bottom sheet（375 设计稿数值 ×2） */
  .shareHotRuleModal.is-open{
    align-items: flex-end;
    justify-content: center;
    padding: 0;
  }
  .shareHotRuleModal-dialog{
    width: 100vw;
    max-width: 100vw;
    border-radius: 32rem 32rem 0 0;
    padding: 32rem;
    padding-top: 60rem;
    padding-bottom: 40rem;
    max-height: 80vh;
    overflow: auto;
  }
  .shareHotRuleModal-close{
    top: 64rem;
    right: 64rem;
    width: 64rem;
    height: 64rem;
  }
   .ar .shareHotRuleModal-close{
    right: unset;
    left: 64rem;
  }
  .shareHotRuleModal-close .icon-close{
    font-size: 48rem;
  }
  .shareHotRuleModal-body{
    margin-top: 64rem;
  }
  .shareHotRuleModal-item + .shareHotRuleModal-item{
    margin-top: 40rem;
  }
  .shareHotRuleModal-itemTitle{
    line-height: 48rem;
  }
  .shareHotRuleModal-itemText{
    margin-top: 8rem;
    line-height: 44rem;
  }
  .shareHotRuleModal-itemText p + p{
    margin-top: 8rem;
  }
}
</style>